import React, { useRef } from 'react';
var VeltCommentsSidebarV2PageModeComposer = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-page-mode-composer-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2PageModeComposer;
